// extracted by css-extract-rspack-plugin
export default {"sectionDivider":"_cf90fa39"};